module.exports = __webpack_public_path__ + "static/media/19ESCAP20.64d836bc.jpg";